// forms
// route page
import { HttpClient } from '@angular/common/http';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { LoginUser } from 'src/app/models/login-user';
import { UserService } from '../../services/user.service';
import { ApiResponse } from 'src/app/models/api-response';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../shared/data-service/data.service.service';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { ConfigService } from '../../services/config.service';
import { AppConfigService } from 'src/app/app-config.service.service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('uploader', { static: true })
  uploader: any;
  optionCompanysSelect: Array<any>;
  cardForm: FormGroup;
  submitted = false;
  isLoading = false;
  msgError: string;
  showError = false;
  file: File | null;
  apiBaseUrl: string;
  showPassword = false;
  typeInputPassword = 'password';
  settings: string;

  dumLoginUser: LoginUser;

  constructor(private formBuilder: FormBuilder, private router: Router, private http: HttpClient,
    private userService: UserService, private data: DataService, private activatedRoute: ActivatedRoute,
    public settingsCompany: CompanySettingsService,
    private route: ActivatedRoute,
    public configService: ConfigService,
    public appConfigService: AppConfigService
  ) {

    // this.route.queryParams.subscribe(params => {
    // });

    this.settings = localStorage.getItem('settings');

    if (!this.settings || this.settings == 'null')
      this.settings = null;
    // validations
    // this.cardForm = fb.group({
    //   materialFormCardNameEx: ['', Validators.required],
    //   materialFormCardEmailEx: ['', [Validators.email, Validators.required]],
    //   materialFormCardConfirmEx: ['', Validators.required],
    //   materialFormCardPasswordEx: ['', Validators.required]
    // });
  }

  // onFileAdd(file: any) {
  //   this.file = file;
  // }
  //
  // onFileRemove() {
  //   this.file = null;
  // }
  //
  // uploadFile() {
  //   if (this.file) {
  //     const data = new FormData();
  //     data.append('file', this.file, this.file.name);
  //     const url = 'http://localhost:3000/api/upload/';
  //
  //   }
  // }
  ngOnInit() {


    var autoStart = localStorage.getItem('autoStart');

    if (autoStart != undefined) {

      var tmpEmail = localStorage.getItem('email');

      this.userService.autologin(tmpEmail).subscribe((data: ApiResponse) => {
        if (data.connected) {
          localStorage.clear();

          if (this.settings)

            localStorage.setItem('termaccepted', data.termAccepted.toString());
          localStorage.setItem('token', data.token);
          localStorage.setItem('userName', data.userName);
          localStorage.setItem('isClient', data.isClient);
          localStorage.setItem('customerid', data.customerID);
          localStorage.setItem('email', tmpEmail);
          localStorage.setItem('currentLat', data.lat);
          localStorage.setItem('currentLong', data.long);
          localStorage.setItem('ubicacion', data.ubicacion);
          this.userService.currentUserName.next(data.userName);
          this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

          this.data.changeUser(data.userName);
          if (data.customerID) {
            this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {
              console.log(result)

              if (result.length > 0){
                // localStorage.setItem("clientplanid","10")
                localStorage.setItem("clientplanid",result[0].clientplanid)
                localStorage.setItem("clienuser",result[0].CLINETUSER)

                localStorage.setItem("iscube", result[0].iscube == 1 ? "Yes" : "No")
                if (result[0].clientplanid != 8){
                  localStorage.setItem('NavbarHorizontal', "Yes")
                  localStorage.setItem('isBabyCube', "Yes")
                } else if(result[0].clientplanid == 10) {
                  localStorage.setItem('NavbarHorizontal', "No")
                  localStorage.setItem('isBabyCube', "No")




                } else {
                  if (result[0].CLIENTUSERSETTING){
                    let objSettings = JSON.parse(result[0].CLIENTUSERSETTING);
                    console.log(objSettings)
                    if (objSettings != undefined){
                      if (objSettings.layout == "Horizontal"){
                        localStorage.setItem('NavbarHorizontal', "Yes")
  
                      } else if (objSettings.layout == "Vertical"){
                        localStorage.setItem('NavbarHorizontal', "No")
                      } else {
                        localStorage.setItem('NavbarHorizontal', "No")
                      }
                    }
                  }
                  localStorage.setItem('isBabyCube', "No")

                }
              }

              if (result.length > 0 && result[0].CLIENTUSERSETTING) {

                let obj = JSON.parse(result[0].CLIENTUSERSETTING);
                obj.regionid = result.RegionID;
                localStorage.setItem('settings', JSON.stringify(obj));

                // localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
                localStorage.setItem('UserCompanyName', result[0].UserCompanyName);


                // This code detect boostrap screen standar resolution. Its used to start always
                // with home page if its mobile screen *************************
                const width = Math.max(
                  document.documentElement.clientWidth,
                  window.innerWidth || 0
                )
                var screenType = 'xl';
                if (width <= 576) { screenType = 'xs' }
                if (width <= 768) { screenType = 'sm' }
                if (width <= 992) { screenType = 'md' }
                if (width <= 1200) { screenType = 'lg' }
                var ignoreStartPage = false;
                if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


                this.userService.settings.next(obj);

                this.configService.loadConfigFromDB().subscribe(resultsett => {
                  this.appConfigService.expandSettings(resultsett[0])
                  let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';
                  if (result.length > 0){
                    // localStorage.setItem("clientplanid","10")
                    localStorage.setItem("clientplanid",result[0].clientplanid)
                    localStorage.setItem("clienuser",result[0].CLINETUSER)

                    if (result[0].clientplanid != 8){
                      if (result[0].clientplanid == 9){
                        this.router.navigateByUrl("/clientDashboard");
                      } else if (result[0].clientplanid == 10){
                        this.router.navigateByUrl("/applications");
                      } else {
                        this.router.navigateByUrl("/home");
                      }
                    } else {
                      this.router.navigateByUrl('/home')
                    }
                  }
                  else{
                    this.router.navigateByUrl('/home')
                  }

                  this.router.navigateByUrl(goto);
                }, err => {
                  this.router.navigateByUrl('/home')
                }
                );
              } else {
                if (result.length > 0){
                  // localStorage.setItem("clientplanid","10")
                  localStorage.setItem("clientplanid",result[0].clientplanid)
                  localStorage.setItem("clienuser",result[0].CLINETUSER)
                  if (result[0].clientplanid != 8){
                    if (result[0].clientplanid == 9){
                      this.router.navigateByUrl("/clientDashboard");
                    } else if (result[0].clientplanid == 10){
                      this.router.navigateByUrl("/applications");
                    } else {
                      this.router.navigateByUrl("/home");
                    }
                  } else {
                    this.router.navigateByUrl('/home');
                  }
                }
                else{
                  this.router.navigateByUrl('/home');
                }
              }
            }, err => {
              this.router.navigateByUrl('/home')
            }
            );
          }

          this.data.clearMenu();

          // this.router.navigateByUrl('/home');
        } else {
          this.showError = true;
          this.msgError = 'Invalid username or password';
        }
      }, error => {
        this.showError = true;
        this.msgError = 'Server internal error, please contact the administrator!';
      });

    }

    sessionStorage.clear();
    localStorage.clear();


    this.cardForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    // this.apiBaseUrl = this.appConfigService.apiBaseUrl;


    this.optionCompanysSelect = [
      { value: '1', label: 'Amazing Control' },
      { value: '2', label: 'CUBE-USA' },
      { value: '3', label: 'South Florida Control' },
      { value: '4', label: 'Template Company' },
      { value: '5', label: 'Travis Brothers' },
    ];

  }

  public resolved(captchaResponse: string): void {
  }

  public onError(errorDetails): void {
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
    this.typeInputPassword = this.showPassword ? 'text' : 'password';
  }
  onSubmit() {

    this.showError = false;
    this.msgError = '';
    this.submitted = true;
    // stop here if form is invalid
    if (this.cardForm.invalid) {
      return;
    }
    this.isLoading = true;
    let value = this.cardForm.value;
    this.userService.login(value).subscribe((data: ApiResponse) => {
      if (data.connected) {
        localStorage.clear();

        if (this.settings)
          localStorage.setItem('settings', this.settings);
        localStorage.setItem('termaccepted', data.termAccepted.toString());
        localStorage.setItem('token', data.token);
        localStorage.setItem('userName', data.userName);
        localStorage.setItem('isClient', data.isClient);
        localStorage.setItem('customerid', data.customerID);
        localStorage.setItem('email', value.username);
        localStorage.setItem('currentLat', data.lat);
        localStorage.setItem('currentLong', data.long);
        localStorage.setItem('ubicacion', data.ubicacion);
        this.userService.currentUserName.next(data.userName);
        this.userService.isClient.next(JSON.parse(data.isClient.toLocaleLowerCase()));

        this.data.changeUser(data.userName);

        if (data.customerID) {
          this.userService.Get_UserSettingsCE(data.customerID).subscribe(result => {
            console.log(result)

            if (result.length > 0){
              localStorage.setItem("iscube", result[0].iscube == 1 ? "Yes" : "No")
              // localStorage.setItem("clientplanid","10")
              localStorage.setItem("clientplanid",result[0].clientplanid)
              localStorage.setItem("clienuser",result[0].CLINETUSER)

              if (result[0].clientplanid != 8){

                localStorage.setItem('NavbarHorizontal', "Yes")
                localStorage.setItem('isBabyCube', "Yes")

              } else if(result[0].clientplanid == 10){
                localStorage.setItem('NavbarHorizontal', "No")
                localStorage.setItem('isBabyCube', "No")
              } else {
                if (result[0].CLIENTUSERSETTING){
                  let objSettings = JSON.parse(result[0].CLIENTUSERSETTING);
                  console.log(objSettings)
                  if (objSettings != undefined){
                    if (objSettings.layout == "Horizontal"){
                      localStorage.setItem('NavbarHorizontal', "Yes")

                    } else if (objSettings.layout == "Vertical"){
                      localStorage.setItem('NavbarHorizontal', "No")
                    } else {
                      localStorage.setItem('NavbarHorizontal', "No")
                    }
                  }
                }
                localStorage.setItem('isBabyCube', "No")

              }
            }

            if (result.length > 0 && result[0].CLIENTUSERSETTING) {
              let obj = JSON.parse(result[0].CLIENTUSERSETTING);
              obj.regionid = result.RegionID;

              localStorage.setItem('settings', JSON.stringify(obj));
              localStorage.setItem('UserCompanyName', result[0].UserCompanyName);

              // This code detect boostrap screen standar resolution. Its used to start always
              // with home page if its mobile screen *************************
              const width = Math.max(
                document.documentElement.clientWidth,
                window.innerWidth || 0
              )
              var screenType = 'xl';
              if (width <= 576) { screenType = 'xs' }
              if (width <= 768) { screenType = 'sm' }
              if (width <= 992) { screenType = 'md' }
              if (width <= 1200) { screenType = 'lg' }
              var ignoreStartPage = false;
              if (screenType == 'xs' || screenType == 'sm') { ignoreStartPage = true }


              this.userService.settings.next(obj);

              this.userService.settings.next(obj);

              this.configService.loadConfigFromDB().subscribe(resultsett => {
                this.appConfigService.expandSettings(resultsett[0])
                let goto = obj.startPage && !ignoreStartPage ? obj.startPage : '/home';

                if (result.length > 0){
                  // localStorage.setItem("clientplanid","10")
                  localStorage.setItem("clientplanid",result[0].clientplanid)
                  localStorage.setItem("clienuser",result[0].CLINETUSER)
                  if (result[0].clientplanid != 8){
                
                    if (result[0].clientplanid == 9){
                        this.router.navigateByUrl("/clientDashboard");
                      } else if (result[0].clientplanid == 10){
                        this.router.navigateByUrl("/applications");
                      } else {
                        this.router.navigateByUrl("/home");
                      }
                  } else {
                    this.router.navigateByUrl(goto);
                  }
                }
                else{
                  this.router.navigateByUrl("/home");
                }



              }, err => {
                this.router.navigateByUrl('/home')
              }
              );
            } else {
              if (result.length > 0){
                // localStorage.setItem("clientplanid","10")
                localStorage.setItem("clientplanid",result[0].clientplanid)
                localStorage.setItem("clienuser",result[0].CLINETUSER)
                if (result[0].clientplanid != 8){
                  if (result[0].clientplanid == 9){
                        this.router.navigateByUrl("/clientDashboard");
                      } else if (result[0].clientplanid == 10){
                        this.router.navigateByUrl("/applications");
                      } else {
                        this.router.navigateByUrl("/home");
                      }
                } else {
                  this.router.navigateByUrl('/home');
                }
              }
              else{
                this.router.navigateByUrl('/home');
              }
            }
          }, err => {
            this.router.navigateByUrl('/home');
          }
          );
        }

        this.data.clearMenu();

        // this.router.navigateByUrl('/home');
      } else {
        this.showError = true;
        this.msgError = 'Invalid username or password';
      }
    }, error => {
      this.showError = true;
      this.msgError = 'Server internal error, please contact the administrator!';
    });
    this.submitted = false;
    this.isLoading = false;
  }
  gotoEstimate() {
  }
  public myDatePickerOptions: IMyOptions = {
    // Your options
  }

}
